import styled from 'styled-components';
import { device } from '../../styles/devices';

export const Container = styled.div``;

export const HeaderContainer = styled.div<{ isFiltersOpen: boolean }>`
  padding-bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  @media ${device.tablet} {
    flex-direction: row;
    align-items: flex-end;
  }
  @media ${device.laptop} {
    align-items: center;
    padding-bottom: ${({ isFiltersOpen }) => (isFiltersOpen ? '24px' : '32px')};
  }
`;

export const ModelFamilyContainer = styled.div`
  position: relative;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  @media ${device.tablet} {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    align-items: unset;
  }
  @media ${device.laptop} {
    gap: 44px;
  }
`;
